import React from 'react'
import { Outlet } from 'react-router-dom'

const Kostil = () => {
  return (
    <Outlet />
  )
}

export default Kostil